import "./RegionTerritory.module.css";
import Header from "@/reusable_sections/Header";
import TerritoryHero from "./sections/TerritoryHero";
import ZoneCardsGrid from "./sections/ZoneCardsGrid";
import Footer from "@/reusable_sections/Footer";
export default function RegionTerritoryPage() {
  return <div>
      <Header />
      <TerritoryHero />
      <ZoneCardsGrid />
      <Footer />
    </div>;
}